// src/storage/persistedHandle.js
import { idbGet, idbSet, idbDel } from "./indexedDB";

const HANDLE_KEY = "vault_dir_handle";

export async function restorePersistedDirHandle() {
  try {
    return await idbGet(HANDLE_KEY);
  } catch {
    return null;
  }
}

export async function persistDirHandle(handle) {
  try {
    await idbSet(HANDLE_KEY, handle);
    return true;
  } catch {
    return false;
  }
}

export async function clearPersistedDirHandle() {
  try {
    await idbDel(HANDLE_KEY);
  } catch {}
}

export async function hasWritePermission(handle) {
  if (!handle) return false;
  try {
    const q = await handle.queryPermission?.({ mode: "readwrite" });
    if (q === "granted") return true;
    const r = await handle.requestPermission?.({ mode: "readwrite" });
    return r === "granted";
  } catch {
    return false;
  }
}
